import {
    createApp
} from 'vue';
import {
    createPinia
} from 'pinia';
import {
    useAuthStore
} from '@/stores/auth';
import {
    getTenantConfig
} from '@/config/tenant.js'; // Bu import'u ekleyin
import App from './App.vue';
import router from './router/index.js';
import i18n from './i18n';
import VueAxios from 'vue-axios';
import axios from '@/axios/axios.js';
import axios_public from '@/axios/axios_public.js';

import BlockViewer from '@/components/BlockViewer.vue';
import Aura from '@primevue/themes/aura';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Editor from 'primevue/editor';
import 'quill/dist/quill.snow.css';

import '@/assets/styles.scss';
import '@/assets/tailwind.css';

// Tenant konfigürasyonunu al ve title'ı dinamik yap
const tenantConfig = getTenantConfig();
document.title = tenantConfig.siteName; // Bu satırı ekleyin

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);

const authStore = useAuthStore();
authStore.initAuth();

app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.app-dark'
        }
    }
});
app.use(i18n);
app.use(ToastService);
app.use(ConfirmationService);

app.use(VueAxios, {
    $myHttp: axios,
    $myHttpPublic: axios_public
});
app.provide('$myHttpPublic', app.config.globalProperties.$myHttpPublic);
app.provide('$myHttp', app.config.globalProperties.$myHttp);

app.component('BlockViewer', BlockViewer);
app.component('Editor', Editor);

app.mount('#app');